import React from 'react'
import { getDarkerHex } from 'utils/ColorUtil'
import { reinforcedWarningColor } from 'utils/constants/ColorTheme'
import i18n from 'simple-react-i18n'
import PropTypes from 'prop-types'
import SmallIndicator from './SmallIndicator'

const RecommendationIndicator = ({ indicator }) => {
    const actionRequired = indicator === 0 || indicator === 2

    const indicatorLabel = () => {
        switch (indicator) {
            case 0:
                return i18n.lower
            case 1:
                return i18n.maintain
            case 2:
                return i18n.increase
            default:
                return i18n.unknown
        }
    }

    return (
        <SmallIndicator
            color={actionRequired && getDarkerHex(reinforcedWarningColor, 25)}
            bgcolor={actionRequired && 'reinforcedWarningStatus.main'}
            borderColor={actionRequired && getDarkerHex(reinforcedWarningColor, 25)}
        >
            {indicatorLabel()}
        </SmallIndicator>
    )
}

RecommendationIndicator.propTypes = {
    indicator: PropTypes.number,
}

export default RecommendationIndicator